import partnerService from 'src/services/partnerService';

export const PARTNERS_REQUEST = '@partner/partners-request';
export const PARTNERS_SUCCESS = '@partner/partners-success';
export const PARTNERS_FAILURE = '@partner/partners-failure';
export const SWITCH_PARTNER = '@partner/switch-partner';

export function getPermittedPartners() {
  return async (dispatch) => {
    try {
      dispatch({ type: PARTNERS_REQUEST });

      const partners = await partnerService.getPermittedPartners();

      if (partners) {
        dispatch({
          type: PARTNERS_SUCCESS,
          payload: {
            partners: partners.partners
          }
        });
      }
    } catch (error) {
      dispatch({ type: PARTNERS_FAILURE });
      throw error;
    }
  };
}

export function setActivePartner(partner) {
  return async (dispatch) => dispatch({
    type: SWITCH_PARTNER,
    payload: {
      partner
    }
  });
}
